"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isArray = _interopRequireDefault(require("../object/isArray"));

var _isFunction = _interopRequireDefault(require("../object/isFunction"));

var _isString = _interopRequireDefault(require("../object/isString"));

var _isEmpty = _interopRequireDefault(require("./isEmpty"));

/**
 * Returns an array with unique values based on an optional key or predicate
 * @param {Array} arr
 * @param {String|Function=}keyOrPredicate
 * @returns {Array}
 */
var uniqueBy = function uniqueBy(arr, keyOrPredicate) {
  if (!(0, _isArray["default"])(arr)) {
    throw new Error('Cannot return unique results from non-array');
  }

  if ((0, _isEmpty["default"])(arr)) return arr;

  var getKey = function getKey(item) {
    if ((0, _isFunction["default"])(keyOrPredicate)) {
      return keyOrPredicate(item);
    }

    if ((0, _isString["default"])(keyOrPredicate)) {
      return item[keyOrPredicate];
    }

    return item.toString();
  };

  var uniqueMap = new Map();
  arr.forEach(function (item) {
    var key = getKey(item);
    uniqueMap.set(key, item);
  });
  return Array.from(uniqueMap.values());
};

var _default = uniqueBy;
exports["default"] = _default;